import { useAdoptedTools } from "../../../marketplace";
import { NextSessionCard } from "../../../scheduler";

/**
 * Shows the week's next session on the home page, but only for therapists who
 * have adopted the Scheduler.
 *
 * The adoption check lives here rather than inside the card so the card itself
 * stays a plain presentation of scheduler data, and so its queries never run
 * for a therapist without the tool.
 */
export default function HomeNextSession() {
    const { data: tools, isLoading } = useAdoptedTools();

    if (isLoading || !tools) return null;
    if (!tools.some((tool) => tool.slug === "scheduler")) return null;

    // The card owns no shell of its own, so the page that places it decides.
    return <NextSessionCard weekOnly className="rounded-xl border border-border-subtle bg-surface-raised p-5 sm:p-6" />;
}
